// src/rms/utils/response.js
// ============================================================================
// Standard service response
// ============================================================================
// Every service function returns { success, data, error }. Inherited from the
// CompareMechanic codebase, which was the one convention genuinely worth
// keeping — it makes every call site handle failure the same way.
//
// Reimplemented here rather than imported from src/Utils so that src/rms has no
// dependency on the legacy tree and the rest of it could be deleted.
// ============================================================================

export const createSuccessResponse = (data) => ({ success: true, data, error: null });

export const createErrorResponse = (error, data = null) => ({
  success: false,
  data,
  error: typeof error === "string" ? error : error?.message || "Unknown error",
});

export const isSuccess = (result) => result?.success === true;

export const getData = (result, fallback = null) => (isSuccess(result) ? result.data : fallback);
